import { useEffect, useState } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"
import axios from "axios"
import { ArrowLeft } from "lucide-react"
import AppLayout from "@/components/app/AppLayout"
import { JitsiEmbed } from "@/components/telehealth/JitsiEmbed"
import { Button } from "@/components/ui/button"
import { API_BASE } from "@/config/api"

const API = API_BASE

export default function VideoCall() {
  const { appointmentId } = useParams()
  const navigate = useNavigate()
  const [session, setSession] = useState(null)
  const [error, setError] = useState("")

  useEffect(() => {
    if (!appointmentId) return
    axios
      .get(`${API}/telehealth/session`, { params: { appointment_id: appointmentId } })
      .then((r) => setSession(r.data))
      .catch((e) => setError(e.response?.data?.detail || "Consultația nu este disponibilă"))
  }, [appointmentId])

  return (
    <AppLayout title="Consultație video">
      <div className="flex flex-col h-[calc(100vh-8rem)]">
        <div className="flex items-center gap-3 mb-4">
          <Button variant="ghost" size="sm" className="rounded-full" asChild>
            <Link to="/app/appointments">
              <ArrowLeft className="h-4 w-4 mr-1" />
              Programări
            </Link>
          </Button>
          {session?.client_name && (
            <p className="text-sm text-muted-foreground">
              Consultație cu {session.client_name}
            </p>
          )}
        </div>
        {error && <p className="text-sm text-destructive mb-4">{error}</p>}
        {session && (
          <div className="flex-1 rounded-2xl border border-border overflow-hidden bg-black/5">
            <JitsiEmbed
              domain={session.domain}
              roomName={session.room_name}
              jwt={session.jwt}
              displayName="Practician"
              onLeave={() => navigate("/app/appointments")}
            />
          </div>
        )}
        {!session && !error && (
          <p className="text-sm text-muted-foreground">Se încarcă camera video…</p>
        )}
      </div>
    </AppLayout>
  )
}
